/**
 * Supported file formats for order import
 */
export const SUPPORTED_ORDER_IMPORT_EXTENSIONS = new Set(['csv', 'xls', 'xlsx']);

export type OrderImportLookupStatus = 'ok' | 'failed' | 'skipped';

export interface OrderImportLookupResult<T> {
  status: OrderImportLookupStatus;
  data?: T;
  errorCode?: string;
  errorMessage?: string;
  reason?: string;
}

export interface OrderImportArticleSummary {
  skuId: string;
  productId: string;
  name: string;
  unit: string;
  salesUnit: string;
  colorCode?: string;
  stockProductNumber?: string;
  stockProductBase?: string;
  isMyMix?: boolean;
}

export interface OrderImportColorSummary {
  colorId: string;
  colorCode: string;
  name: string;
  rgb: string;
}

export interface OrderImportSourceColumns {
  skuId: string;
  quantity: string;
  description: string;
  myMixColorId: string;
}

export interface ProcessedOrderImportLine {
  rowId?: string;
  lineNumber: number;
  skuId: string;
  quantity: number | undefined;
  description?: string;
  myMixColorId?: string;
  /** Original color code as received from the import file (preserves casing). */
  originalMyMixColorId?: string;
  errors: string[];
  enrichment?: {
    product: OrderImportLookupResult<OrderImportArticleSummary>;
    color: OrderImportLookupResult<OrderImportColorSummary>;
    myMix: OrderImportLookupResult<OrderImportArticleSummary>;
  };
}

export interface OrderImportProcessResponse {
  fileName: string;
  extension: string;
  sheetName: string;
  totalRows: number;
  validRows: number;
  invalidRows: number;
  sourceColumns: OrderImportSourceColumns;
  rows: ProcessedOrderImportLine[];
}

export interface OrderImportRevalidateLineInput {
  rowId?: string;
  lineNumber?: number;
  skuId: string;
  quantity: number | string | undefined;
  description?: string;
  myMixColorId?: string;
  deleted?: boolean;
}

export interface OrderImportRevalidateRequest {
  fileName?: string;
  locale?: string;
  sourceColumns?: OrderImportSourceColumns;
  rows: OrderImportRevalidateLineInput[];
}

export type OrderImportCommitRequest = OrderImportRevalidateRequest;

export interface OrderImportCommitResponse {
  canUpload: boolean;
  result: OrderImportProcessResponse;
}

export interface OrderImportTemplateResponse {
  url: string | null;
}
